import React, { useState, useEffect, useContext } from 'react';
import ReactPaginate from 'react-paginate';
import Navbar from "../Navbar/Navbar";
import "./courses.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faRightLong, faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import AnimatedPage from '../AnimatedPage/AnimatedPage';
import PlaceHolder from './placeholder';
import IMAGE from "./back.png";
import { UserDataContext } from '../UserContext/UserContext';

function Courses(props) {
  const { Base_url } = useContext(UserDataContext);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(false);

  const DataPerPage = 4;
  const pagesVisited = pageNumber * DataPerPage;
  const pageCount = Math.ceil(
    courses.filter((item) =>
      item.name.toLowerCase().includes(list.toLowerCase())
    ).length / DataPerPage
  );

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const getLessonComments = async () => {
    try {
      setLoading(true);
      const data = await axios.get(`${Base_url}/courses/`);
      setCourses(data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  useEffect(() => {
    getLessonComments();
  }, []);

  const filteredData = courses.filter((item) =>
    item.name.toLowerCase().includes(list.toLowerCase())
  );

  return (
    <>
      <AnimatedPage>
        <div className='pb-5 courses-parent' id="courses">
          <div className="page-section" data-aos="fade-up">
            <div className="container">
              <div className="row">
                {/* Sidebar */}
                <div className="sidebar col-md-12 col-lg-5">
                  <div className="sidebar-block">
                    <h3 className="sidebar-title">Search</h3>
                    <form action="#" className="search-form my-4">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-outline search-input"
                          placeholder="Type a keyword To Search"
                          onChange={(event) => {
                            const keyword = event.target.value;
                            setList(keyword);
                          }}
                        />
                        <span className="icon mai-search" />
                      </div>
                    </form>
                  </div>
                  <div className="sidebar-block">
                    <h3 className="sidebar-title">Quick View</h3>
                    <p>
                      Welcome to our course search! Whether you're a student,
                      professional, or lifelong learner, our comprehensive catalog
                      offers a wide range of courses across various disciplines. Use
                      the search box below to find your desired course by name.
                      Simply start typing, and our powerful search feature will
                      instantly display relevant results.
                    </p>
                  </div>
                </div>

                {/* Cards Section */}
                {loading ? (
                  <PlaceHolder />
                ) : (
                  <div className='col-12 my-1 col-lg-7 card-container' data-aos="fade-right">
                    <div className="row">
                      {filteredData
                        .slice(pagesVisited, pagesVisited + DataPerPage)
                        .map((item) => (
                          <div
                            key={item.id}
                            className="col-12 col-md-6 d-flex justify-content-center mb-4"
                          >
                            <div
                              className="card-blog"
                              style={{
                                width: "320px",
                                height: "360px",
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              {/* Lessons Count Badge */}
                              {item.lessons_count > 0 && (
                                <span className="lessons-badge">
                                  {item.lessons_count} Lessons
                                </span>
                              )}
                              <div
                                className="header"
                                style={{ height: "240px", overflow: "hidden" }}
                              >
                                <span
                                  className="post-thumb"
                                  style={{ display: "block", height: "100%" }}
                                >
                                  <img
                                    src={item.image}
                                    alt={item.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      objectPosition: "center",
                                    }}
                                  />
                                </span>
                              </div>
                              <div className="body text-center py-2 px-2">
                                <Link
                                  to={`/Checkout/${item.id}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  <p className="fw-bold text-dark mb-1">
                                    {item.name}
                                  </p>
                                  {/* Star Rating */}
                                  <div className="course-rating mb-1">
                                    {[...Array(5)].map((_, index) => {
                                      const starValue = index + 1;
                                      if (item.rate >= starValue) {
                                        return <FontAwesomeIcon key={index} icon={faStar} className="star-filled" />;
                                      } else if (item.rate >= starValue - 0.5) {
                                        return <FontAwesomeIcon key={index} icon={faStarHalfAlt} className="star-filled" />;
                                      } else {
                                        return <FontAwesomeIcon key={index} icon={faStar} className="star-empty" />;
                                      }
                                    })}
                                  </div>
                                  <p className="text-muted mb-0">
                                    Enroll Now <FontAwesomeIcon icon={faRightLong} />
                                  </p>
                                </Link>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Pagination */}
              {courses.length <= 4 ? (
                ""
              ) : (
                <ReactPaginate
                  previousLabel={"Back"}
                  nextLabel={"Next"}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName={"paginationBttns"}
                  previousLinkClassName={"btn-dark btn"}
                  nextLinkClassName={"btn-dark btn"}
                  disabledClassName={"paginationDisabled"}
                  activeClassName={"paginationActive"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                />
              )}
            </div>
          </div>
        </div>
      </AnimatedPage>
    </>
  );
}

export default Courses;
